<template>
	<div>

		<modal 
		:title="$t('account/bookings.Choose your template')"
		:hide-footer="true"
		size="md"
		ref="modal">

			<div class="list-group list-group-flush">

				<div 
				v-for="template in templates"
				:key="'template-'+template.id"
				class="list-group-item d-flex justify-content-between align-items-center bg-transparent">
	 
					<span>
						{{template.name|str_limit(50)}}
					</span>

					<div>

						<button 
						@click="selectTemplate(template)"
						class="btn btn-outline-primary btn-sm">
							{{$t('account/bookings.Choose')}}
						</button>


						<b-dropdown 
		                variant="outline-primary toggle-template btn-sm ml-2" 
		                right>

		                    <template #button-content>
		                        <i class="fe fe-more-vertical"></i>
		                    </template>

		                    <b-dropdown-item-button
		                    @click="editTemplate(template)">
		                        {{$t('account/bookings.Edit')}}
		                    </b-dropdown-item-button>

		                    <b-dropdown-item-button
		                    @click="deleteTemplate(template)">
		                        {{$t('account/bookings.Delete')}}
		                    </b-dropdown-item-button>

		                </b-dropdown>

					</div>

				</div> <!-- /.list-group-item -->

			</div> <!-- /.list-group -->


			<template #footer>
				<button 
				class="btn rounded-pill btn-neutral" 
				@click="$refs.modal.close">
					{{$t('app.Close')}}
				</button>
			</template>

		</modal>

		<modal 
		:title="$t('account/bookings.Edit my template')"
		size="lg"
		:disabled="!name"
		@submit="updateTemplate"
		:loading="loading"
		:button="$t('app.Save')"
		ref="template">

			<input-text
			:label="$t('account/bookings.Template name')"
			v-model="name" />

		</modal>

	</div>
</template>

<script>

	import {mapState} from 'vuex'

	export default {

		data() {
			return {
				deleting: false,
				loading: false,
				current: null,
				name: null
			}
		},

		computed: {

			...mapState({
				booking: state => state.booking,
			}),

			templates() {
				return this.booking.templates
			},

		},

		methods: {

			open() {
				this.$refs.modal.open()
			},

			editTemplate(template) {
				this.current = template
				this.name = template.name
				this.$refs.template.open()
			},

			updateTemplate(template) {

				this.loading = true 

				axios
				.post('/account/bookings/template', {
					id: this.current.id,
					name: this.name,
					data: this.current.data
				})
				.then(response => {
					this.loading = false
					this.$store.commit('booking/setTemplates', response.data.templates)
					this.$flash(this.$t('account/bookings.Template updated'))
					this.$refs.template.close()
				})
				.catch(error => {
					this.loading = false
					this.$flash(this.$t('app.An error has occured'))
				})

			},

			deleteTemplate(template) {

				axios
				.post('/account/bookings/template/'+template.id, {
					_method: 'DELETE'
				})
				.then(response => {
					this.$store.commit('booking/setTemplates', response.data)
					this.$flash(this.$t('account/bookings.Template deleted'))

					if(!response.data.length)
					{
						this.$refs.modal.close()
					}
					
				})
				.catch(error => {
					this.$flash(this.$t('app.An error has occured'))
				})

			},

			selectTemplate(template) {
				this.$store.dispatch('booking/applyTemplate', template)
				this.$refs.modal.close()
			}

		}

	}
</script>